import { saveEmblemData, wizardStore } from "../../../stores/wizard"

export default function SpecialInstructionsTextarea() {
  const handleSpecialInstructions = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const specialInstructions = event.target.value
    saveEmblemData(wizardStore.step.id, { specialInstructions })
  }

  return (
    <div className='w-full flex flex-col items-start gap-2 my-2'>
      <h2 className="">
        <span className="font-bold uppercase mr-2">Special Instructions</span>
        <span>(Optional)</span>
      </h2>
      <textarea
        className='border w-full rounded h-auto p-1 outline-none'
        style={{ border: "1px solid #ccc" }}
        onChange={handleSpecialInstructions}
        placeholder={wizardStore.step?.specialInstructionsPlaceholder || 'Please provide additional, detailed instructions here to help with the production of your design.'}
        value={wizardStore.emblemData[wizardStore.step?.id]?.specialInstruction}
      />
    </div>
  )
}